// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_7a-0";
export var optionCard = "_7a-1";